import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'uber-eats-orders',
            label: 'Uber Eats Orders',
            routerLink: ['/extensions/sales/uber-eats-orders'],
            icon: 'shopping-cart',
        },
        'sales',
    ),
];
